var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 12 12",
    enableBackground: "new 0 0 12 12",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#251F2C",
    height: 1,
    width: 11,
    x: 0.5,
    y: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#251F2C",
    height: 1,
    width: 11,
    x: 0.5,
    y: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#251F2C",
    height: 1,
    width: 11,
    x: 0.5,
    y: 8.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.f9888960a3d42a0458ff681bb351ee27.svg";
export { ForwardRef as ReactComponent };